import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllAlerts } from "../../api/request/dashboard/dashboard";

export const fetchAlerts = createAsyncThunk('alerts/get', async (_, { getState }) => {
    try {
        const accountId = getState().accountSummary.accountId;
        const { data } = await getAllAlerts(accountId);
        return data;
    } catch (err) {
        return []
    }
})